import { render, staticRenderFns } from "./AttractivityResearch.vue?vue&type=template&id=90ca804a&"
import script from "./AttractivityResearch.vue?vue&type=script&lang=js&"
export * from "./AttractivityResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports